import { SentryReporterInterface } from "@imagine/frontend-base";
import * as Sentry from "@sentry/react";
import { SeverityLevel } from "@sentry/react";

export class SentryReporterWeb implements SentryReporterInterface {
  private version: string = "unknown";
  private name: string = "unknown";
  captureException(
    error: Error,
    data?: Record<string, unknown>,
    userData?: Record<string, unknown>,
    severity?: "fatal" | "error" | "warning" | "info" | "log" | "debug",
  ): void {
    const scope = new Sentry.Scope();
    if (userData) {
      scope.setUser(userData);
    }
    if (data) {
      scope.setContext("Data", data);
    }
    if (severity) {
      scope.setLevel(severity as SeverityLevel);
    }
    scope.setContext(this.name, { Version: this.version });
    Sentry.captureException(error, scope);
    console.error(error, data);
  }
  setVersion(version: string): void {
    this.version = version;
  }
  setName(name: string): void {
    this.name = name;
  }
}
